import React from "react";
import { IFXTooltip } from "../../../IFXTooltip";
import { IFXIcons } from "../../../IFXIcons";

/**
 * NewLabelIconRenderer
 * Like LabelIconCol, but shows icon conditionally (default: true)
 * @param {object} props
 * @param {any} props.value - The label value
 * @param {object} props.tooltipProps - Tooltip props for the icon
 * @param {object} props.iconProps - Icon props
 * @param {boolean} [props.showIcon=true] - Whether to show the icon
 * @param {"left"|"right"} [props.iconPosition="right"] - Position of the icon relative to the value
 */
export const NewLabelIconRenderer = ({
  value,
  tooltipProps,
  iconProps,
  showIcon = true,
  iconPosition = "right",
}) => {
  const icon = showIcon && (
    <div className="float-left action-col-container iconLabelRight">
      <IFXTooltip {...tooltipProps}>
        <div className="table-icon-col">
          <IFXIcons iconSource="svg" icon="question_default" {...iconProps} />
        </div>
      </IFXTooltip>
    </div>
  );

  const label = (
    <div className="float-left ifx-label ifx-text-overflow">
      <span>{value}</span>
    </div>
  );

  return (
    <div className="d-flex">
      {iconPosition === "left" && icon}
      {label}
      {iconPosition === "right" && icon}
    </div>
  );
};
